import React from 'react';
import cx from 'classnames';
import { CloseIcon } from '../../icons';
import './Toaster.scss';
export const Toaster = ({ isOpen, onClose, children }) => {
    const onClickAway = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };
    return (React.createElement("div", { onClick: onClickAway, className: cx('toaster__overlay', { 'toaster__overlay--open': isOpen }) },
        React.createElement("div", { className: "toaster__modal" },
            React.createElement("button", { type: "button", className: "toaster__modal__close-button", onClick: onClose, "aria-label": "Close modal" },
                React.createElement(CloseIcon, null)),
            children)));
};
//# sourceMappingURL=Toaster.js.map